export enum PromotionExpirationTemplateSearchTypes {
    CustomerId = "CustomerId",
    CustomerName = "CustomerName",
    ItemNumber = "ItemNumber",
    ItemName = "ItemName",
    ProductLineNumber = "ProductLineNumber",
    ProductLineName = "ProductLineName",
    ProductLineCategoryNumber = "ProductLineCategoryNumber",
    PromotionId = "PromotionId",
    PromotionDescription = "PromotionDescription",
    ControlNumber = "ControlNumber",
    TemplateId = "TemplateId",
    Action = "Action"
};
